export const VARUS_DATASET = {
  HKA: 174.53,
  WBL: 20.83,
  'Pre-Op_HKA': 5,
  TW: 80.7,
  '%TW': 50,
  JL_A: 371.34,
  TW_JL_A: 89.88,
  TW_Osteotomy: 73.32,
  JL_CoFH: 453.38,
  TW_JL_CoFH: 84.28,
  LPFA: 90,
  mLDFA: 86.85,
  MPTA: 83.91,
  LDTA: 90,
  PPFA: 90,
  ANSA: 170,
  PDFA: 77.24,
  PPTA: 77.47,
  ADTA: 80,
  JLCA: 2.53
};

export const VALGUS_DATASET = {
  HKA: 173.39,
  WBL: 50.05,
  'Pre-Op_HKA': 4,
  TW: 59.2,
  '%TW': 86.23,
  JL_A: 344.72,
  TW_JL_A: 82.88,
  TW_Osteotomy: 56.04,
  JL_CoFH: 410.14,
  TW_JL_CoFH: 81.46,
  LPFA: 90,
  mLDFA: 84.68,
  MPTA: 92.19,
  LDTA: 90,
  PPFA: 83.17,
  ANSA: 170,
  PDFA: 83.17,
  PPTA: 83.28,
  ADTA: 80,
  JLCA: 0.9
};
